module.exports = __webpack_public_path__ + "static/media/MicroSquare-Regular.1706264d.ttf";